import { PostHogProvider as Provider } from '@posthog/react';
import type { ReactNode } from 'react';

import { getPostHog } from '~/lib/posthog';

export function PostHogProvider({ children }: { children: ReactNode }) {
  const client = getPostHog();

  if (!client) {
    return children;
  }

  return <Provider client={client}>{children}</Provider>;
}
